import { defineStore } from 'pinia'
import { ref } from 'vue'
import { apiAtividadeTipo } from '@/services/atividadeTipo'
import { useAlert } from '@/composables/useAlert'
import { useError } from '@/composables/useError'

export const useAtividadesTipos = defineStore('useAtividadesTipos', () => {
   const { validarErro } = useError()
   const { alertError, alertSucess, alertWarn } = useAlert()
   const { editar, obter, obterPorId, registrar } = apiAtividadeTipo()

   const loadingAtividadeTipo = ref(false)
   const loadingAtividadeTipoPorId = ref(false)
   const loadingRegistrar = ref(false)
   const loadingEditar = ref(false)

   const atividadeTipoPorId = ref(null)
   const atividadesTipos = ref(null)

   const registrarAtividadeTipo = async (payload) => {
      try {
         loadingRegistrar.value = true
         await registrar(payload)
         return alertSucess('Registro salvo com sucesso.')
      } catch (error) {
         return validarErro(error)
      } finally {
         loadingRegistrar.value = false
      }
   }

   const editarAtividadeTipo = async (payload) => {
      try {
         loadingEditar.value = true
         await editar(payload)
         return alertSucess('Registro salvo com sucesso.')
      } catch (error) {
         return validarErro(error)
      } finally {
         loadingEditar.value = false
      }
   }

   const obterAtividadeTipoPorId = async (id) => {
      try {
         loadingAtividadeTipoPorId.value = true
         const resposta = await obterPorId(id)
         atividadeTipoPorId.value = resposta
      } catch (error) {
         return alertError('Não foi possível carregar registro.')
      } finally {
         loadingAtividadeTipoPorId.value = false
      }
   }

   const obterAtividadeTipo = async (params) => {
      try {
         loadingAtividadeTipo.value = true
         const resposta = await obter(params)
         atividadesTipos.value = resposta
      } catch (error) {
         return alertError('Não foi possível carregar registro.')
      } finally {
         loadingAtividadeTipo.value = false
      }
   }

   return {
      loadingAtividadeTipo,
      loadingAtividadeTipoPorId,
      loadingEditar,
      loadingRegistrar,
      atividadesTipos,
      atividadeTipoPorId,
      registrarAtividadeTipo,
      editarAtividadeTipo,
      obterAtividadeTipo,
      obterAtividadeTipoPorId
   }
})
